import { Button, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Create,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useGetList,
  useCreateContext
} from 'react-admin';
import SelectEmployeeFieldCreate from './components/SelectEmployeeFieldCreate';
import SelectSubMerchantFieldCreate from './components/SelectSubMerchantFieldCreate';
import { getSubmerchantInfo } from '../../services/SubMerchant';
import { getMerchantName } from '../../services/Merchant';
import BackButton from '../common/BackButton';
import { KeyboardBackspace } from '@mui/icons-material';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';



const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid Color.Main',
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};
export const TerminalCreate = (props) => {
  const { data } = useGetList('SubMerchant', {filter: {status: 1}});
  const employee = useGetList('Employee', {filter: {status: 1}});

  return (
    <Create {...props} redirect="list">
      <SimpleForm toolbar={<CustomToolbar />}>
        <Grid sx={{ textAlign: 'left' }}>
          <Button
            endIcon={<PointOfSaleIcon sx={{ color: Color.Main }} />}
            sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
            size="medium"
          >
            <Typography variant="h3">Create Terminal</Typography>
          </Button>
        </Grid>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <MerchantName />
        <Grid container sx={{ pt: '3rem' }} justifyContent="space-between">
          <Grid item md={5} sm={12} xs={12}>
            <TextInput required source="alias" variant="outlined" fullWidth />
          </Grid>
          <Grid item md={5} sm={12} xs={12}>
            <SelectEmployeeFieldCreate allEmployee={employee.data} />
          </Grid>
          <Grid item md={5} sm={12} xs={12}>
            <SelectSubMerchantFieldCreate allSubmerchants={data} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

const MerchantName = () => {
  const { record } = useCreateContext();
  const [merchantName, setMerchantName] = useState('');
  useEffect(() => {
    const getData = async () => {
      const submerchantInfo = await getSubmerchantInfo(record.submerchantID);
      const tmpMerchantName = await getMerchantName(
        parseInt(submerchantInfo.merchantID)
      );
      setMerchantName(tmpMerchantName);
    };

    getData();
  }, [record]);

  return (
    <Typography variant="h6" pt="1rem" pl="1rem">
      Merchant: <strong>{merchantName}</strong>
    </Typography>
  );
};

const CustomToolbar = (props) => {
  return (
    <Toolbar
      {...props}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'right',
      }}
    >
      <BackButton startIcon={<KeyboardBackspace />} sx={backButton} />
      <SaveButton sx={saveButton} />
    </Toolbar>
  );
};
